@if (productCategoriesBlock() && categories()) {
    <section class="flex flex-wrap justify-around gap-4 pb-8 md:gap-6 md:pb-10 lg:gap-10 lg:pb-12 xl:justify-center">
        <div class="flex w-full flex-col justify-center gap-4">
            <div class="flex flex-col gap-4 text-center md:text-center">
                <h2 class="lg:text-display-small text-headline-medium text-left lg:text-center">
                    {{ productCategoriesBlock().translations_refs | getTranslation: "title" }}
                </h2>

                <p class="text-title-small pb-4 text-left lg:text-center">
                    {{ productCategoriesBlock().translations_refs | getTranslation: "description" }}
                </p>
            </div>
        </div>

        @for (category of categories(); track category.id) {
            <a
                [href]="category | pathFromItem: 'category'"
                class="mb-auto flex max-w-41 min-w-41 flex-col items-center justify-center gap-4 sm:max-w-45 sm:min-w-45 md:max-w-55 md:min-w-55 lg:max-w-75 lg:min-w-75"
            >
                <div
                    class="border-primary hover:bg-primary/5 flex size-44 items-center justify-center rounded-full border-2 md:size-60 lg:size-72 xl:size-80"
                >
                    <div class="size-32 items-center justify-center md:size-48 lg:size-64 xl:size-72">
                        <img
                            [ngSrc]="category?.image | getDirectusImage"
                            alt="Category Image"
                            class="h-full w-full object-contain"
                            width="100"
                            height="100"
                        />
                    </div>
                </div>
                <span class="text-title-medium text-neutral-20 text-center">
                    {{ category.translations_refs | getTranslation: "title" }}
                </span>
            </a>
        }
    </section>
}
